// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1365":"dfb5da91","1932":"3999ef02","5904":"c79e82f2"}[chunkId] + ".chunk.css";
};